import { useEffect, useRef } from 'react';
import { trackEvent } from '../lib/telemetry';

// Usage telemetry: one search_used per screen visit, the first time the search
// box holds any text. The words themselves are never sent.
export function useSearchTelemetry(query) {
  const sentRef = useRef(false);
  useEffect(() => {
    if (!query || sentRef.current) return;
    sentRef.current = true;
    trackEvent('search_used');
  }, [query]);
}

export default useSearchTelemetry;
